module.exports = __webpack_public_path__ + "img/sina01.fef45ca5.png";